import { IClauseEntity } from '../../entitites/common/clause.entity';

export class ClauseDto {
  readonly name: string;
  readonly content: string;
  readonly condition: string | null;

  constructor(entity: IClauseEntity) {
    this.name = entity.name;
    this.content = entity.content;
    this.condition = entity.condition;
  }
}
